import { render } from "./MultiStageProgressBar.vue?vue&type=template&id=97eaca3c"
import script from "./MultiStageProgressBar.vue?vue&type=script&lang=js"
export * from "./MultiStageProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__